// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"15ca4932","702":"25274475"}[chunkId] + ".chunk.js";
};